/**
 * config.js
 * Application configuration constants
 */

// OpenClaw API Configuration
export const CONFIG = {
  apiUrl: '/v1/responses',
  authToken: 'e16845470895e52ab59a79cb57bd14dfde709a77820a8225',
  user: 'marino-webchat',
  agentId: 'main',
  model: 'openclaw:main'
};

// Hermes API Configuration
export const HERMES_CONFIG = {
  apiUrl: '/v1/chat/completions',
  apiKey: 'hermes-secret-key-1778415151',
};

// Available agents
export const AGENTS = [
  { id: 'main',      name: 'Eliza',    emoji: '🌿', model: 'openclaw:main' },
  { id: 'samantha',  name: 'Samantha', emoji: '🎧', model: 'openclaw:samantha' },
  { id: 'cipher',    name: 'Cipher',   emoji: '🛡️', model: 'openclaw:cipher' },
  { id: 'nova',      name: 'Nova',     emoji: '🔭', model: 'openclaw:nova' },
  { id: 'spark',     name: 'Spark',    emoji: '⚡', model: 'openclaw:spark' },
  { id: 'lex',       name: 'Lex',      emoji: '⚖️', model: 'openclaw:lex' },
  { id: 'qwen',      name: 'Qwen',     emoji: '🔮', model: 'ollama/qwen3.5:397b-cloud' },
  { id: 'hermes',    name: 'Hermes',   emoji: '⚕️', model: 'hermes-agent' },
];
